import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    container: {
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(),
        left: 0,
        right: 0
    },
    suggestion: {
        display: 'block'
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
    },
    divider: {
        height: theme.spacing()
    },
    input: {
        minWidth: 260
    }
});

export type Classes = WithStyles<typeof styles>
